import "./style.scss";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import type { MenuItemProps } from "@mui/material";
import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { ArticleCompletionStatus } from "store/articleStore";
import type { PaymentStatus } from "store/types";

import { StyledSelect } from "../StyledSelect";
import type { StatusSelectColorRules } from "./utils";

export type StatusSelectOption = { label: string; value: PaymentStatus | ArticleCompletionStatus };
interface StatusSelectProps {
    value?: number;
    options: StatusSelectOption[];
    onChange: (value: any) => void;
    fullWidth?: boolean;
    disabled?: boolean;
    /**
     * Set a min-width style
     */
    minWidth?: string;
    /**
     * Color rules to render status color
     */
    colorRules?: StatusSelectColorRules;
    /**
     * Hide color status (on the left)
     */
    hideColorStatus?: boolean;
    /**
     * Options to render in dropdown
     */
    dropdownOptions?: StatusSelectOption[];
}

const StatusSelect = ({
    value = -1,
    options,
    onChange,
    fullWidth,
    disabled = false,
    minWidth = "115px",
    colorRules = {},
    hideColorStatus = false,
    dropdownOptions,
}: StatusSelectProps) => {
    const [t] = useTranslation();
    // const [localValue, setLocalValue] = useState(value ?? 0)

    const handleValueChange = (e: any) => {
        // setLocalValue(e.target.value)
        onChange(e.target.value);
    };

    const statusColor = colorRules?.[value] || "black";

    const showMarkAsLabel = value === -1;

    return (
        <div
            className={classNames({
                "status-select": true,
                "mark-as-label": showMarkAsLabel,
            })}
            onClick={(e) => e.stopPropagation()}
        >
            <StyledSelect
                disabled={disabled}
                IconComponent={KeyboardArrowDownIcon}
                MenuProps={{ MenuListProps: { disablePadding: true } }}
                noGradient
                sx={{
                    fontFamily: "Poppins",
                    minWidth,
                    width: fullWidth ? "100%" : "140px",
                    fontSize: "13px",
                    backgroundColor: "white",
                    "&.MuiOutlinedInput-root": {
                        position: "relative",
                        overflow: "hidden",
                        ...(!showMarkAsLabel &&
                            !hideColorStatus && {
                                "&::after": {
                                    content: "''",
                                    width: "4px",
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    backgroundColor: statusColor,
                                    borderRadius: "4px 0 0 4px",
                                },
                            }),
                        height: showMarkAsLabel ? "29px" : "2rem",
                        ".MuiSvgIcon-root": {
                            transform: "scale(0.8)",
                            // color: slice.status != undefined ? paymentStatusColors[slice.status]?.text ?? "#6f669c" : "#6f669c",
                        },
                        ".Mui-disabled": {
                            cursor: "not-allowed",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaeaea !important",
                            borderWidth: "1px",
                        },
                        "& .MuiSelect-select": {
                            padding: "4px 24px 4px 8px",
                        },
                    },
                    height: "50px",
                    padding: "4px 8px",
                    // color: slice.status != undefined ? paymentStatusColors[slice.status]?.text ?? "#6f669c" : "#6f669c",
                    // backgroundColor: slice.status != undefined ? paymentStatusColors[slice.status]?.background ?? "#FFFFFF" : "#FFFFFF"
                }}
                value={value}
                size="small"
                renderValue={(selected: any) => {
                    if (showMarkAsLabel) return <div>{t("Articles.MarkAs")}</div>;
                    else return options.find((choice) => choice.value == selected)?.label;
                }}
                onChange={(e: any) => handleValueChange(e)}
            >
                {options?.length > 0 &&
                    (dropdownOptions ?? options).map((choice) => (
                        <MenuItemStatus
                            value={choice.value}
                            key={choice.value}
                            style={{ fontSize: "12px" }}
                            colorRules={colorRules}
                            hideColorStatus={hideColorStatus}
                        >
                            {choice.label}
                        </MenuItemStatus>
                    ))}
            </StyledSelect>
        </div>
    );
};

interface MenuItemStatusProps extends MenuItemProps {
    colorRules: StatusSelectColorRules;
    hideColorStatus: boolean;
}

const MenuItemStatus = styled((props: MenuItemProps) => <MenuItem {...props} />)((props: MenuItemStatusProps) => {
    const statusColor = props.colorRules?.[props["data-value"]] || "black";

    return {
        "&.MuiMenuItem-root": {
            margin: "0",
            // width: "150px",
            fontSize: "13px",
            // color: "#5D9B62",
            fontFamily: "Poppins",
            // backgroundColor: "",
            // borderRadius: variables["border-radius"],
            position: "relative",
            "&:not(:last-child)": {
                borderBottom: "1px solid #eaeaea",
            },
            ...(!props.hideColorStatus && {
                "&::after": {
                    content: "''",
                    width: "4px",
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: statusColor,
                    // borderRadius: "4px 0 0 4px",
                },
            }),
            "&.Mui-selected": {
                // color: "#5D9B62",
                // backgroundColor: "",
            },
            "&:hover": {
                // backgroundColor: "rgba(152, 212, 158, 0.4)",
            },
        },
    };
});

export default StatusSelect;
